"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.medianDependencies = void 0;

var _dependenciesAddGenerated = require("./dependenciesAdd.generated.js");

var _dependenciesCompareGenerated = require("./dependenciesCompare.generated.js");

var _dependenciesDivideGenerated = require("./dependenciesDivide.generated.js");

var _dependenciesPartitionSelectGenerated = require("./dependenciesPartitionSelect.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var medianDependencies = {
  addDependencies: _dependenciesAddGenerated.addDependencies,
  compareDependencies: _dependenciesCompareGenerated.compareDependencies,
  divideDependencies: _dependenciesDivideGenerated.divideDependencies,
  partitionSelectDependencies: _dependenciesPartitionSelectGenerated.partitionSelectDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createMedian: _factoriesAny.createMedian
};
exports.medianDependencies = medianDependencies;